import { createReducer } from 'reduxsauce';
import { produce } from 'immer';
import find from 'ramda/src/find';
import findIndex from 'ramda/src/findIndex';
import propEq from 'ramda/src/propEq';
import { VendorTypes } from '~/actions';
import { InitialGlobalSearchResult } from '~/services/config';
import { removeStatus } from '~/services/util';
import { toast } from 'react-toastify';

const initialBlogPosts = {
    appends: {
        blog_categories: [],
        blog_id: [],
        categories: [],
        order: 'id',
        per_page: 10,
        sort: 'DESC',
    },
    posts: {
        data: [],
        current_page: 0,
        last_page: 0,
        per_page: 10,
        from: 0,
        to: 0,
        total: 0,
    },
};

const initialState = {
    status: [],
    categories: {
        all: [],
        popular: [],
    },
    companies: [],
    vendorCompanies: {
        data: [],
        current_page: 0,
        last_page: 0,
        per_page: 10,
        from: 0,
        to: 0,
        total: 0,
    },
    allVRCompanyInfo: [],
    vendorCompaniesAlphabet: [],
    vendorAwards: [],
    recentProducts: {
        data: [],
        from: 1,
        last_page: 1,
        page: 1,
        per_page: 5,
        to: 1,
        total: 0,
    },
    popularProducts: {
        data: [],
        from: 1,
        last_page: 1,
        page: 1,
        per_page: 5,
        to: 1,
        total: 0,
    },
    superadminCompanies: {
        current_page: 0,
        data: [],
        last_page: 0,
        per_page: 10,
        from: 0,
        to: 0,
        total: 0,
    },
    superadminUsers: {
        current_page: 0,
        data: [],
        last_page: 0,
        per_page: 10,
        from: 0,
        to: 0,
        total: 0,
    },
    superadminContent: {
        current_page: 0,
        data: [],
        last_page: 0,
        per_page: 10,
        from: 0,
        to: 0,
        total: 0,
    },
    superadminCategory: {
        current_page: 0,
        data: [],
        last_page: 0,
        per_page: 10,
        from: 0,
        to: 0,
        total: 0,
    },
    blogPosts: initialBlogPosts,
    globalSearchResult: InitialGlobalSearchResult,
};

const getcategoriesRequest = produce((draft, action) => {});
const getcategoriesSuccess = produce((draft, action) => {
    draft.categories = action.response;
});
const getcategoriesFailure = produce((draft, action) => {});

const getcategorypopularproductsRequest = produce((draft, action) => {
    draft.status.push('pending-vgg');
});
const getcategorypopularproductsSuccess = produce((draft, action) => {
    const { categoryId, data } = action.response;
    const idx = findIndex(propEq('id', categoryId), draft.categories.all);
    if (idx > -1) {
        draft.categories.all[idx].popular = data;
    }
    draft.status = removeStatus('pending-vgg', draft.status);
});
const getcategorypopularproductsFailure = produce((draft, action) => {
    draft.status = removeStatus('pending-vgg', draft.status);
});

const getallcategorypopularproductsRequest = produce((draft, action) => {
    const { loading = true } = action;
    if (loading) draft.status.push('pending-vagg');
});
const getallcategorypopularproductsSuccess = produce((draft, action) => {
    const categories = action.response;
    categories.map((item) => {
        const idx = findIndex(propEq('id', item.id), draft.categories.all);
        const popularIdx = findIndex(propEq('id', item.id), draft.categories.popular);
        if (idx > -1) {
            draft.categories.all[idx].popular = item?.products;
            draft.categories.all[idx].product_total = item?.product_total;
            draft.categories.all[idx].total_verified_ratings = item?.total_verified_ratings;
        }
        if (popularIdx > -1) {
            draft.categories.popular[popularIdx].product_total = item?.product_total;
            draft.categories.popular[popularIdx].total_verified_ratings = item?.total_verified_ratings;
        }
    });
    draft.status = removeStatus('pending-vagg', draft.status);
});
const getallcategorypopularproductsFailure = produce((draft, action) => {
    draft.status = removeStatus('pending-vagg', draft.status);
});

const getcategoryproductsRequest = produce((draft, action) => {
    draft.status.push('pending-vgp');
});
const getcategoryproductsSuccess = produce((draft, action) => {
    const { categoryId, data } = action.response;
    const idx = findIndex(propEq('id', categoryId), draft.categories.all);
    if (idx > -1) {
        draft.categories.all[idx].products = data;
    }
    draft.status = removeStatus('pending-vgp', draft.status);
});
const getcategoryproductsFailure = produce((draft, action) => {
    draft.status = removeStatus('pending-vgp', draft.status);
});

const getvendorcompanyRequest = produce((draft, action) => {
    draft.status.push('pending-vgv');
});
const getvendorcompanySuccess = produce((draft, action) => {
    const { id } = action.response;
    const idx = findIndex(propEq('id', id), draft.companies);
    if (idx > -1) {
        draft.companies[idx] = { ...draft.companies[idx], ...action.response };
    } else {
        draft.companies.push(action.response);
    }
    draft.status = removeStatus('pending-vgv', draft.status);
});
const getvendorcompanyFailure = produce((draft, action) => {
    draft.status = removeStatus('pending-vgv', draft.status);
});

const getcompanyadminsRequest = produce((draft, action) => {
    draft.status.push('pending-vca');
});
const getcompanyadminsSuccess = produce((draft, action) => {
    const { companyId, admins } = action.response;
    const idx = findIndex(propEq('id', Number(companyId)), draft.companies);
    if (idx > -1) {
        draft.companies[idx].admins = admins;
    }
    draft.status = removeStatus('pending-vca', draft.status);
});
const getcompanyadminsFailure = produce((draft, action) => {
    draft.status = removeStatus('pending-vca', draft.status);
});

const getvendorcompaniesRequest = produce((draft, action) => {
    const { loading = true } = action;
    if (loading) draft.status.push('pending-mgo');
});
const getvendorcompaniesSuccess = produce((draft, action) => {
    const { sort, data } = action.response;
    if (sort === 'alphabet') {
        draft.vendorCompaniesAlphabet = data;
    } else {
        draft.vendorCompanies = data;
    }
    draft.status = removeStatus('pending-mgo', draft.status);
});
const getvendorcompaniesFailure = produce((draft, action) => {
    draft.status = removeStatus('pending-mgo', draft.status);
});

const getvrcompanydetailRequest = produce((draft, action) => {
    draft.status.push('pending-vcd');
});
const getvrcompanydetailSuccess = produce((draft, action) => {
    draft.status = removeStatus('pending-vcd', draft.status);
});
const getvrcompanydetailFailure = produce((draft, action) => {
    draft.status = removeStatus('pending-vcd', draft.status);
});

const getvendorcategoriesRequest = produce((draft, action) => {
    draft.status.push('pending-vcm');
});
const getvendorcategoriesSuccess = produce((draft, action) => {
    draft.status = removeStatus('pending-vcm', draft.status);
    draft.superadminCategory = action.response;
});
const getvendorcategoriesFailure = produce((draft, action) => {
    draft.status = removeStatus('pending-vcm', draft.status);
});

const getvendorratingsRequest = produce((draft, action) => {
    draft.status.push('pending-vrm');
});
const getvendorratingsSuccess = produce((draft, action) => {
    draft.status = removeStatus('pending-vrm', draft.status);
    draft.vendorRatings = action.response;
});
const getvendorratingsFailure = produce((draft, action) => {
    draft.status = removeStatus('pending-vrm', draft.status);
});

const getallvendorcompaniesRequest = produce((draft, action) => {
    const { loading = true } = action;
    if (loading) {
        draft.status.push('pending-vav');
    }
});
const getallvendorcompaniesSuccess = produce((draft, action) => {
    draft.allVRCompanyInfo = action.response;
    draft.status = removeStatus('pending-vav', draft.status);
});
const getallvendorcompaniesFailure = produce((draft, action) => {
    draft.status = removeStatus('pending-vav', draft.status);
});

const savevendorratingRequest = produce((draft, action) => {
    draft.status.push('pending-msv');
});
const savevendorratingSuccess = produce((draft, action) => {
    draft.status = removeStatus('pending-msv', draft.status);
});
const savevendorratingFailure = produce((draft, action) => {
    draft.status = removeStatus('pending-msv', draft.status);
});

const getvendorawardsRequest = produce((draft, action) => {
    draft.status.push('pending-mva');
});
const getvendorawardsSuccess = produce((draft, action) => {
    draft.status = removeStatus('pending-mva', draft.status);
    draft.vendorAwards = action.response.awards;
});
const getvendorawardsFailure = produce((draft, action) => {
    draft.status = removeStatus('pending-mva', draft.status);
});

const getrecentlyupdatedproductsRequest = produce((draft, action) => {
    draft.status.push('pending-mru');
});
const getrecentlyupdatedproductsSuccess = produce((draft, action) => {
    draft.status = removeStatus('pending-mru', draft.status);
    draft.recentProducts = action.response;
});
const getrecentlyupdatedproductsFailure = produce((draft, action) => {
    draft.status = removeStatus('pending-mru', draft.status);
});

const getpopularproductsRequest = produce((draft, action) => {
    draft.status.push('pending-mpd');
});
const getpopularproductsSuccess = produce((draft, action) => {
    draft.status = removeStatus('pending-mpd', draft.status);
    draft.popularProducts = action.response;
});
const getpopularproductsFailure = produce((draft, action) => {
    draft.status = removeStatus('pending-mpd', draft.status);
});

const globalsearchRequest = produce((draft, action) => {
    draft.status.push('pending-mgs');
});
const globalsearchSuccess = produce((draft, action) => {
    draft.status = removeStatus('pending-mgs', draft.status);
    const { target, search_text, data } = action.response;
    if (!target || target === '' || target === 'all' || target === 'people' || target === 'companies' || target === 'products') {
        draft.globalSearchResult = {
            ...draft.globalSearchResult,
            ...data,
            search_text,
        };
    } else {
        draft.globalSearchResult.search_text = search_text;
        draft.globalSearchResult[target] = data;
    }
});
const globalsearchFailure = produce((draft, action) => {
    draft.status = removeStatus('pending-mgs', draft.status);
});

const savevrproductRequest = produce((draft, action) => {
    draft.status.push('pending-vsp');
});
const savevrproductSuccess = produce((draft, action) => {
    draft.status = removeStatus('pending-vsp', draft.status);
});
const savevrproductFailure = produce((draft, action) => {
    draft.status = removeStatus('pending-vsp', draft.status);
});

const savevrcompanyRequest = produce((draft, action) => {
    draft.status.push('pending-vsc');
});
const savevrcompanySuccess = produce((draft, action) => {
    draft.status = removeStatus('pending-vsc', draft.status);
});
const savevrcompanyFailure = produce((draft, action) => {
    draft.status = removeStatus('pending-vsc', draft.status);
});

const savevrphotoRequest = produce((draft, action) => {
    draft.status.push('pending-vph');
});
const savevrphotoSuccess = produce((draft, action) => {
    draft.status = removeStatus('pending-vph', draft.status);
});
const savevrphotoFailure = produce((draft, action) => {
    draft.status = removeStatus('pending-vph', draft.status);
});

const getvrcompanyRequest = produce((draft, action) => {
    draft.status.push('pending-vvc');
});
const getvrcompanySuccess = produce((draft, action) => {
    const { id } = action.response;
    const idx = findIndex(propEq('id', id), draft.companies);
    if (idx > -1) {
        draft.companies[idx].products = action.response.products;
        draft.companies[idx].ratings_breakdown = action.response.ratings_breakdown;
        draft.companies[idx].ratings_by_job = action.response.ratings_by_job;
        draft.companies[idx].stats = action.response.stats;
    } else {
        draft.companies.push(action.response);
    }
    draft.status = removeStatus('pending-vvc', draft.status);
});
const getvrcompanyFailure = produce((draft, action) => {
    draft.status = removeStatus('pending-vvc', draft.status);
});

const postvrcompanyadminRequest = produce((draft, action) => {
    draft.status.push('pending-vpc');
});
const postvrcompanyadminSuccess = produce((draft, action) => {
    draft.status = removeStatus('pending-vpc', draft.status);
});
const postvrcompanyadminFailure = produce((draft, action) => {
    draft.status = removeStatus('pending-vpc', draft.status);
});

const postblogadminRequest = produce((draft, action) => {
    draft.status.push('pending-vba');
});
const postblogadminSuccess = produce((draft, action) => {
    draft.status = removeStatus('pending-vba', draft.status);
});
const postblogadminFailure = produce((draft, action) => {
    draft.status = removeStatus('pending-vba', draft.status);
});

const getblogRequest = produce((draft, action) => {
    draft.status.push('pending-vbr');
});
const getblogSuccess = produce((draft, action) => {
    const { id, blog } = action.response;
    const idx = findIndex(propEq('id', id), draft.companies);
    if (idx > -1) {
        draft.companies[idx] = { ...draft.companies[idx], blog };
    }
    draft.status = removeStatus('pending-vbr', draft.status);
});
const getblogFailure = produce((draft, action) => {
    draft.status = removeStatus('pending-vbr', draft.status);
});

const saveblogRequest = produce((draft, action) => {
    draft.status.push('pending-vpb');
});
const saveblogSuccess = produce((draft, action) => {
    draft.status = removeStatus('pending-vpb', draft.status);
});
const saveblogFailure = produce((draft, action) => {
    draft.status = removeStatus('pending-vpb', draft.status);
});

const getblogpostsRequest = produce((draft, action) => {
    draft.blogPosts = initialBlogPosts;
    draft.status.push('pending-vbp');
});
const getblogpostsSuccess = produce((draft, action) => {
    draft.blogPosts = action.response;
    draft.status = removeStatus('pending-vbp', draft.status);
});
const getblogpostsFailure = produce((draft, action) => {
    draft.status = removeStatus('pending-vbp', draft.status);
});

const saveblogpostRequest = produce((draft, action) => {
    draft.status.push('pending-vsb');
});
const saveblogpostSuccess = produce((draft, action) => {
    draft.status = removeStatus('pending-vsb', draft.status);
});
const saveblogpostFailure = produce((draft, action) => {
    draft.status = removeStatus('pending-vsb', draft.status);
});

const deleteblogpostRequest = produce((draft, action) => {
    draft.status.push('pending-vdp');
});
const deleteblogpostSuccess = produce((draft, action) => {
    draft.status = removeStatus('pending-vdp', draft.status);
});
const deleteblogpostFailure = produce((draft, action) => {
    draft.status = removeStatus('pending-vdp', draft.status);
});

const postadduserRequest = produce((draft, action) => {
    draft.status.push('pending-vpa');
});
const postadduserSuccess = produce((draft, action) => {
    draft.status = removeStatus('pending-vpa', draft.status);
});
const postadduserFailure = produce((draft, action) => {
    draft.status = removeStatus('pending-vpa', draft.status);
});

const postremoveuserRequest = produce((draft, action) => {
    draft.status.push('pending-vru');
});
const postremoveuserSuccess = produce((draft, action) => {
    draft.status = removeStatus('pending-vru', draft.status);
});
const postremoveuserFailure = produce((draft, action) => {
    draft.status = removeStatus('pending-vru', draft.status);
});

const postsaveproductRequest = produce((draft, action) => {
    draft.status.push('pending-vps');
});
const postsaveproductSuccess = produce((draft, action) => {
    const product = action.response.product;
    draft.status = removeStatus('pending-vps', draft.status);
    const cId = findIndex(propEq('id', product.parent_id), draft.companies);
    if (cId > -1) {
        const pId = findIndex(propEq('id', product.id), draft.companies[cId].products);
        draft.companies[cId].products[pId] = {
            ...draft.companies[cId].products[pId],
            ...product,
        };
    }
});
const postsaveproductFailure = produce((draft, action) => {
    draft.status = removeStatus('pending-vps', draft.status);
});

const postsavecontentRequest = produce((draft, action) => {
    draft.status.push('pending-vpd');
});
const postsavecontentSuccess = produce((draft, action) => {
    draft.status = removeStatus('pending-vpd', draft.status);
});
const postsavecontentFailure = produce((draft, action) => {
    draft.status = removeStatus('pending-vpd', draft.status);
});

const postsavevrmediaRequest = produce((draft, action) => {
    draft.status.push('pending-vsm');
});
const postsavevrmediaSuccess = produce((draft, action) => {
    draft.status = removeStatus('pending-vsm', draft.status);
});
const postsavevrmediaFailure = produce((draft, action) => {
    draft.status = removeStatus('pending-vsm', draft.status);
});

const postsaveproductmediaRequest = produce((draft, action) => {
    draft.status.push('pending-vmp');
});
const postsaveproductmediaSuccess = produce((draft, action) => {
    draft.status = removeStatus('pending-vmp', draft.status);
});
const postsaveproductmediaFailure = produce((draft, action) => {
    draft.status = removeStatus('pending-vmp', draft.status);
});

const postdeleteproductmediaRequest = produce((draft, action) => {
    draft.status.push('pending-vdpm');
});
const postdeleteproductmediaSuccess = produce((draft, action) => {
    draft.status = removeStatus('pending-vdpm', draft.status);
});
const postdeleteproductmediaFailure = produce((draft, action) => {
    draft.status = removeStatus('pending-vdpm', draft.status);
});

const getsuperadminbusinessRequest = produce((draft, action) => {
    draft.status.push('pending-vsab');
});
const getsuperadminbusinessSuccess = produce((draft, action) => {
    draft.status = removeStatus('pending-vsab', draft.status);
    draft.superadminCompanies = action.response;
});
const getsuperadminbusinessFailure = produce((draft, action) => {
    draft.status = removeStatus('pending-vsab', draft.status);
});

const getsuperadminusersRequest = produce((draft, action) => {
    draft.status.push('pending-vsau');
});
const getsuperadminusersSuccess = produce((draft, action) => {
    draft.status = removeStatus('pending-vsau', draft.status);
    draft.superadminUsers = action.response;
});
const getsuperadminusersFailure = produce((draft, action) => {
    draft.status = removeStatus('pending-vsau', draft.status);
});

const getsuperadmincontentRequest = produce((draft, action) => {
    draft.status.push('pending-vsac');
});
const getsuperadmincontentSuccess = produce((draft, action) => {
    draft.status = removeStatus('pending-vsac', draft.status);
    draft.superadminContent = action.response;
});
const getsuperadmincontentFailure = produce((draft, action) => {
    draft.status = removeStatus('pending-vsac', draft.status);
});

const postsuperadminbanduserRequest = produce((draft, action) => {
    draft.status.push('pending-vsbu');
});
const postsuperadminbanduserSuccess = produce((draft, action) => {
    draft.status = removeStatus('pending-vsbu', draft.status);
});
const postsuperadminbanduserFailure = produce((draft, action) => {
    draft.status = removeStatus('pending-vsbu', draft.status);
});

const postsuperadminrestoreuserRequest = produce((draft, action) => {
    draft.status.push('pending-vsru');
});
const postsuperadminrestoreuserSuccess = produce((draft, action) => {
    draft.status = removeStatus('pending-vsru', draft.status);
});
const postsuperadminrestoreuserFailure = produce((draft, action) => {
    draft.status = removeStatus('pending-vsru', draft.status);
});

const postvendorconnectRequest = produce((draft, action) => {
    draft.status.push('pending-vpvc');
});
const postvendorconnectSuccess = produce((draft, action) => {
    draft.status = removeStatus('pending-vpvc', draft.status);
});
const postvendorconnectFailure = produce((draft, action) => {
    draft.status = removeStatus('pending-vpvc', draft.status);
});

const postcategorysaveRequest = produce((draft, action) => {
    draft.status.push('pending-pcs');
});
const postcategorysaveSuccess = produce((draft, action) => {
    const { category } = action.response;
    const id = findIndex(propEq('id', Number(category.id)), draft.superadminCategory.data);
    draft.superadminCategory.data[id] = category;
    draft.status = removeStatus('pending-pcs', draft.status);
});
const postcategorysaveFailure = produce((draft, action) => {
    draft.status = removeStatus('pending-pcs', draft.status);
});

const postcategorydeleteRequest = produce((draft, action) => {
    draft.status.push('pending-pcd');
});
const postcategorydeleteSuccess = produce((draft, action) => {
    const { category } = action.response;
    draft.status = removeStatus('pending-pcd', draft.status);
});
const postcategorydeleteFailure = produce((draft, action) => {
    draft.status = removeStatus('pending-pcd', draft.status);
});

const postcategoryrestoreRequest = produce((draft, action) => {
    draft.status.push('pending-pcr');
});
const postcategoryrestoreSuccess = produce((draft, action) => {
    const { category } = action.response;
    draft.status = removeStatus('pending-pcr', draft.status);
});
const postcategoryrestoreFailure = produce((draft, action) => {
    draft.status = removeStatus('pending-pcr', draft.status);
});

const postvendorratingRequest = produce((draft, action) => {
    draft.status.push('pending-pvr');
});
const postvendorratingSuccess = produce((draft, action) => {
    const { rating } = action.response;
    const idx = findIndex(propEq('id', Number(rating.id)), draft.vendorRatings.data);
    draft.vendorRatings.data[idx] = rating;
    draft.status = removeStatus('pending-pvr', draft.status);
    toast.success('Success');
});
const postvendorratingFailure = produce((draft, action) => {
    draft.status = removeStatus('pending-pvr', draft.status);
});

const resetRequest = produce((draft) => {
    draft.status = [];
});

const clearRequest = produce((draft, action) => (draft = initialState));

export const reducer = createReducer(initialState, {
    [VendorTypes.GETCATEGORIES_REQUEST]: getcategoriesRequest,
    [VendorTypes.GETCATEGORIES_FAILURE]: getcategoriesFailure,
    [VendorTypes.GETCATEGORIES_SUCCESS]: getcategoriesSuccess,

    [VendorTypes.GETCATEGORYPOPULARPRODUCTS_REQUEST]: getcategorypopularproductsRequest,
    [VendorTypes.GETCATEGORYPOPULARPRODUCTS_FAILURE]: getcategorypopularproductsFailure,
    [VendorTypes.GETCATEGORYPOPULARPRODUCTS_SUCCESS]: getcategorypopularproductsSuccess,

    [VendorTypes.GETALLCATEGORYPOPULARPRODUCTS_REQUEST]: getallcategorypopularproductsRequest,
    [VendorTypes.GETALLCATEGORYPOPULARPRODUCTS_FAILURE]: getallcategorypopularproductsFailure,
    [VendorTypes.GETALLCATEGORYPOPULARPRODUCTS_SUCCESS]: getallcategorypopularproductsSuccess,

    [VendorTypes.GETCATEGORYPRODUCTS_REQUEST]: getcategoryproductsRequest,
    [VendorTypes.GETCATEGORYPRODUCTS_FAILURE]: getcategoryproductsFailure,
    [VendorTypes.GETCATEGORYPRODUCTS_SUCCESS]: getcategoryproductsSuccess,

    [VendorTypes.GETVENDORCOMPANY_REQUEST]: getvendorcompanyRequest,
    [VendorTypes.GETVENDORCOMPANY_SUCCESS]: getvendorcompanySuccess,
    [VendorTypes.GETVENDORCOMPANY_FAILURE]: getvendorcompanyFailure,

    [VendorTypes.GETCOMPANYADMINS_REQUEST]: getcompanyadminsRequest,
    [VendorTypes.GETCOMPANYADMINS_SUCCESS]: getcompanyadminsSuccess,
    [VendorTypes.GETCOMPANYADMINS_FAILURE]: getcompanyadminsFailure,

    [VendorTypes.GETVENDORCOMPANIES_REQUEST]: getvendorcompaniesRequest,
    [VendorTypes.GETVENDORCOMPANIES_SUCCESS]: getvendorcompaniesSuccess,
    [VendorTypes.GETVENDORCOMPANIES_FAILURE]: getvendorcompaniesFailure,

    [VendorTypes.GETVRCOMPANYDETAIL_REQUEST]: getvrcompanydetailRequest,
    [VendorTypes.GETVRCOMPANYDETAIL_SUCCESS]: getvrcompanydetailSuccess,
    [VendorTypes.GETVRCOMPANYDETAIL_FAILURE]: getvrcompanydetailFailure,

    [VendorTypes.GETVENDORCATEGORIES_REQUEST]: getvendorcategoriesRequest,
    [VendorTypes.GETVENDORCATEGORIES_SUCCESS]: getvendorcategoriesSuccess,
    [VendorTypes.GETVENDORCATEGORIES_FAILURE]: getvendorcategoriesFailure,

    [VendorTypes.GETVENDORRATINGS_REQUEST]: getvendorratingsRequest,
    [VendorTypes.GETVENDORRATINGS_SUCCESS]: getvendorratingsSuccess,
    [VendorTypes.GETVENDORRATINGS_FAILURE]: getvendorratingsFailure,

    [VendorTypes.GETALLVENDORCOMPANIES_REQUEST]: getallvendorcompaniesRequest,
    [VendorTypes.GETALLVENDORCOMPANIES_SUCCESS]: getallvendorcompaniesSuccess,
    [VendorTypes.GETALLVENDORCOMPANIES_FAILURE]: getallvendorcompaniesFailure,

    [VendorTypes.SAVEVENDORRATING_REQUEST]: savevendorratingRequest,
    [VendorTypes.SAVEVENDORRATING_SUCCESS]: savevendorratingSuccess,
    [VendorTypes.SAVEVENDORRATING_FAILURE]: savevendorratingFailure,

    [VendorTypes.GETVENDORAWARDS_REQUEST]: getvendorawardsRequest,
    [VendorTypes.GETVENDORAWARDS_SUCCESS]: getvendorawardsSuccess,
    [VendorTypes.GETVENDORAWARDS_FAILURE]: getvendorawardsFailure,

    [VendorTypes.GETRECENTLYUPDATEDPRODUCTS_REQUEST]: getrecentlyupdatedproductsRequest,
    [VendorTypes.GETRECENTLYUPDATEDPRODUCTS_SUCCESS]: getrecentlyupdatedproductsSuccess,
    [VendorTypes.GETRECENTLYUPDATEDPRODUCTS_FAILURE]: getrecentlyupdatedproductsFailure,

    [VendorTypes.GETPOPULARPRODUCTS_REQUEST]: getpopularproductsRequest,
    [VendorTypes.GETPOPULARPRODUCTS_SUCCESS]: getpopularproductsSuccess,
    [VendorTypes.GETPOPULARPRODUCTS_FAILURE]: getpopularproductsFailure,

    [VendorTypes.GLOBALSEARCH_REQUEST]: globalsearchRequest,
    [VendorTypes.GLOBALSEARCH_SUCCESS]: globalsearchSuccess,
    [VendorTypes.GLOBALSEARCH_FAILURE]: globalsearchFailure,

    [VendorTypes.SAVEVRPRODUCT_REQUEST]: savevrproductRequest,
    [VendorTypes.SAVEVRPRODUCT_SUCCESS]: savevrproductSuccess,
    [VendorTypes.SAVEVRPRODUCT_FAILURE]: savevrproductFailure,

    [VendorTypes.SAVEVRCOMPANY_REQUEST]: savevrcompanyRequest,
    [VendorTypes.SAVEVRCOMPANY_SUCCESS]: savevrcompanySuccess,
    [VendorTypes.SAVEVRCOMPANY_FAILURE]: savevrcompanyFailure,

    [VendorTypes.SAVEVRPHOTO_REQUEST]: savevrphotoRequest,
    [VendorTypes.SAVEVRPHOTO_SUCCESS]: savevrphotoSuccess,
    [VendorTypes.SAVEVRPHOTO_FAILURE]: savevrphotoFailure,

    [VendorTypes.GETVRCOMPANY_REQUEST]: getvrcompanyRequest,
    [VendorTypes.GETVRCOMPANY_SUCCESS]: getvrcompanySuccess,
    [VendorTypes.GETVRCOMPANY_FAILURE]: getvrcompanyFailure,

    [VendorTypes.POSTVRCOMPANYADMIN_REQUEST]: postvrcompanyadminRequest,
    [VendorTypes.POSTVRCOMPANYADMIN_SUCCESS]: postvrcompanyadminSuccess,
    [VendorTypes.POSTVRCOMPANYADMIN_FAILURE]: postvrcompanyadminFailure,

    [VendorTypes.POSTBLOGADMIN_REQUEST]: postblogadminRequest,
    [VendorTypes.POSTBLOGADMIN_SUCCESS]: postblogadminSuccess,
    [VendorTypes.POSTBLOGADMIN_FAILURE]: postblogadminFailure,

    [VendorTypes.GETBLOG_REQUEST]: getblogRequest,
    [VendorTypes.GETBLOG_SUCCESS]: getblogSuccess,
    [VendorTypes.GETBLOG_FAILURE]: getblogFailure,

    [VendorTypes.SAVEBLOG_REQUEST]: saveblogRequest,
    [VendorTypes.SAVEBLOG_SUCCESS]: saveblogSuccess,
    [VendorTypes.SAVEBLOG_FAILURE]: saveblogFailure,

    [VendorTypes.GETBLOGPOSTS_REQUEST]: getblogpostsRequest,
    [VendorTypes.GETBLOGPOSTS_SUCCESS]: getblogpostsSuccess,
    [VendorTypes.GETBLOGPOSTS_FAILURE]: getblogpostsFailure,

    [VendorTypes.SAVEBLOGPOST_REQUEST]: saveblogpostRequest,
    [VendorTypes.SAVEBLOGPOST_SUCCESS]: saveblogpostSuccess,
    [VendorTypes.SAVEBLOGPOST_FAILURE]: saveblogpostFailure,

    [VendorTypes.DELETEBLOGPOST_REQUEST]: deleteblogpostRequest,
    [VendorTypes.DELETEBLOGPOST_SUCCESS]: deleteblogpostSuccess,
    [VendorTypes.DELETEBLOGPOST_FAILURE]: deleteblogpostFailure,

    [VendorTypes.POSTADDUSER_REQUEST]: postadduserRequest,
    [VendorTypes.POSTADDUSER_SUCCESS]: postadduserSuccess,
    [VendorTypes.POSTADDUSER_FAILURE]: postadduserFailure,

    [VendorTypes.POSTREMOVEUSER_REQUEST]: postremoveuserRequest,
    [VendorTypes.POSTREMOVEUSER_SUCCESS]: postremoveuserSuccess,
    [VendorTypes.POSTREMOVEUSER_FAILURE]: postremoveuserFailure,

    [VendorTypes.POSTSAVEPRODUCT_REQUEST]: postsaveproductRequest,
    [VendorTypes.POSTSAVEPRODUCT_SUCCESS]: postsaveproductSuccess,
    [VendorTypes.POSTSAVEPRODUCT_FAILURE]: postsaveproductFailure,

    [VendorTypes.POSTSAVECONTENT_REQUEST]: postsavecontentRequest,
    [VendorTypes.POSTSAVECONTENT_SUCCESS]: postsavecontentSuccess,
    [VendorTypes.POSTSAVECONTENT_FAILURE]: postsavecontentFailure,

    [VendorTypes.POSTSAVEVRMEDIA_REQUEST]: postsavevrmediaRequest,
    [VendorTypes.POSTSAVEVRMEDIA_SUCCESS]: postsavevrmediaSuccess,
    [VendorTypes.POSTSAVEVRMEDIA_FAILURE]: postsavevrmediaFailure,

    [VendorTypes.POSTSAVEPRODUCTMEDIA_REQUEST]: postsaveproductmediaRequest,
    [VendorTypes.POSTSAVEPRODUCTMEDIA_SUCCESS]: postsaveproductmediaSuccess,
    [VendorTypes.POSTSAVEPRODUCTMEDIA_FAILURE]: postsaveproductmediaFailure,

    [VendorTypes.POSTDELETEPRODUCTMEDIA_REQUEST]: postdeleteproductmediaRequest,
    [VendorTypes.POSTDELETEPRODUCTMEDIA_SUCCESS]: postdeleteproductmediaSuccess,
    [VendorTypes.POSTDELETEPRODUCTMEDIA_FAILURE]: postdeleteproductmediaFailure,

    [VendorTypes.GETSUPERADMINBUSINESS_REQUEST]: getsuperadminbusinessRequest,
    [VendorTypes.GETSUPERADMINBUSINESS_SUCCESS]: getsuperadminbusinessSuccess,
    [VendorTypes.GETSUPERADMINBUSINESS_FAILURE]: getsuperadminbusinessFailure,

    [VendorTypes.GETSUPERADMINUSERS_REQUEST]: getsuperadminusersRequest,
    [VendorTypes.GETSUPERADMINUSERS_SUCCESS]: getsuperadminusersSuccess,
    [VendorTypes.GETSUPERADMINUSERS_FAILURE]: getsuperadminusersFailure,

    [VendorTypes.GETSUPERADMINCONTENT_REQUEST]: getsuperadmincontentRequest,
    [VendorTypes.GETSUPERADMINCONTENT_SUCCESS]: getsuperadmincontentSuccess,
    [VendorTypes.GETSUPERADMINCONTENT_FAILURE]: getsuperadmincontentFailure,

    [VendorTypes.POSTSUPERADMINBANDUSER_REQUEST]: postsuperadminbanduserRequest,
    [VendorTypes.POSTSUPERADMINBANDUSER_SUCCESS]: postsuperadminbanduserSuccess,
    [VendorTypes.POSTSUPERADMINBANDUSER_FAILURE]: postsuperadminbanduserFailure,

    [VendorTypes.POSTSUPERADMINRESTOREUSER_REQUEST]: postsuperadminrestoreuserRequest,
    [VendorTypes.POSTSUPERADMINRESTOREUSER_SUCCESS]: postsuperadminrestoreuserSuccess,
    [VendorTypes.POSTSUPERADMINRESTOREUSER_FAILURE]: postsuperadminrestoreuserFailure,

    [VendorTypes.POSTVENDORCONNECT_REQUEST]: postvendorconnectRequest,
    [VendorTypes.POSTVENDORCONNECT_SUCCESS]: postvendorconnectSuccess,
    [VendorTypes.POSTVENDORCONNECT_FAILURE]: postvendorconnectFailure,

    [VendorTypes.POSTCATEGORYSAVE_REQUEST]: postcategorysaveRequest,
    [VendorTypes.POSTCATEGORYSAVE_SUCCESS]: postcategorysaveSuccess,
    [VendorTypes.POSTCATEGORYSAVE_FAILURE]: postcategorysaveFailure,

    [VendorTypes.POSTCATEGORYDELETE_REQUEST]: postcategorydeleteRequest,
    [VendorTypes.POSTCATEGORYDELETE_SUCCESS]: postcategorydeleteSuccess,
    [VendorTypes.POSTCATEGORYDELETE_FAILURE]: postcategorydeleteFailure,

    [VendorTypes.POSTCATEGORYRESTORE_REQUEST]: postcategoryrestoreRequest,
    [VendorTypes.POSTCATEGORYRESTORE_SUCCESS]: postcategoryrestoreSuccess,
    [VendorTypes.POSTCATEGORYRESTORE_FAILURE]: postcategoryrestoreFailure,

    [VendorTypes.POSTVENDORRATING_REQUEST]: postvendorratingRequest,
    [VendorTypes.POSTVENDORRATING_SUCCESS]: postvendorratingSuccess,
    [VendorTypes.POSTVENDORRATING_FAILURE]: postvendorratingFailure,

    [VendorTypes.RESET_REQUEST]: resetRequest,
    [VendorTypes.CLEAR_REQUEST]: clearRequest,
});
